import { UserPlan } from '@/contexts/UserContext';

/** Pro-level access: pro or copilot */
export function canAccessFullTool(userPlan: UserPlan): boolean {
  return userPlan === 'pro' || userPlan === 'copilot';
}

export function canSaveLoad(userPlan: UserPlan): boolean {
  return userPlan === 'pro' || userPlan === 'copilot';
}

export function canExportFull(userPlan: UserPlan): boolean {
  return userPlan === 'pro' || userPlan === 'copilot';
}

/** Copilot-only access (Risk Copilot modules) - now included in Pro */
export function canAccessCopilot(userPlan: UserPlan): boolean {
  return userPlan === 'copilot' || userPlan === 'pro';
}

export function limitPreviewRows<T>(items: T[], userPlan: UserPlan): T[] {
  if (userPlan === 'pro' || userPlan === 'copilot') {
    return items;
  }
  return items.slice(0, 2);
}

export function addPreviewNote(data: any[][], userPlan: UserPlan): any[][] {
  if (userPlan === 'pro' || userPlan === 'copilot' || data.length <= 1) {
    return data;
  }
  
  const limitedData = data.slice(0, 2);
  return limitedData;
}
